const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
const brandAsset = (fileName) => `${publicUrl}/brand/elsa/${fileName}`;

export const ELSA_BRAND_COLORS = Object.freeze({
  navy: "#173F5F",
  marine: "#0A2740",
  red: "#E63B3B",
  slate: "#627B8D",
  white: "#FFFFFF",
});

export const ELSA_BRAND_TAGLINE =
  "Gardez le contrôle, où que vous soyez.";

export const ELSA_BRAND_ASSETS = Object.freeze({
  emblemColor: brandAsset("emblem-color-web.png"),
  emblemNavy: brandAsset("emblem-navy-web.png"),
  emblemWhite: brandAsset("emblem-white-web.png"),
  logoHorizontalColor: brandAsset("logo-horizontal-color-web.png"),
  logoHorizontalDark: brandAsset("logo-horizontal-dark-web.png"),
  logoHorizontalLight: brandAsset("logo-horizontal-light-web.png"),
  logoHorizontalNavy: brandAsset("logo-horizontal-navy-web.png"),
  logoHorizontalWhite: brandAsset("logo-horizontal-white-web.png"),
  logoVerticalDark: brandAsset("logo-vertical-dark.png"),
  logoVerticalLight: brandAsset("logo-vertical-light.png"),
});
